const colors = {
    theme: {
        yaelGreen: '#00A7E3',
        yaelGreen80: 'rgba(0, 167, 227, 0.8)',
        yaelGreen10: 'rgba(0, 167, 227, 0.1)',
        yaelGrey:  'rgb(113,116,139)',
        yaelGrey10:  'rgba(113,116,139, 0.1)',
        yaelGrey30:  'rgba(113,116,139, 0.3)',
        yaelBlue:  '#0077B6',
        yaelBlue80:  'rgba(0, 119, 182, 0.8)',
        yaelBlue10:  'rgba(0, 119, 182, 0.1)',
        yaelDark:  '#0B172A',
        yaelWhite: 'rgb(255,255,255)',
        yaelOrange: '#E2007A',
    },
    prompt: {
        errorBackground: 'rgb(254,246,246)',
        errorBorder: 'rgb(252,218,218)',
        errorText: 'rgb(245,80,82)',
        errorSubText: 'rgb(99,107,123)'
    }
};

export default colors;
